import React, { useEffect, useState } from "react";
import "./ModalPreview.css";
import DownloadPopup from "../../portfolio/DownloadPopup";

async function downloadPDF(pdfUrl, setDownloadMessage, setShowPopup, onClose) {
    try {
        setDownloadMessage("Seu download começará em instantes. Verifique sua pasta de downloads.");
        setShowPopup(true);

        const response = await fetch(pdfUrl);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'preview.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        setTimeout(() => {
            setShowPopup(false);
            onClose();
        }, 3000);
    } catch (error) {
        console.error("Error downloading PDF:", error.message);
        setDownloadMessage("Ocorreu um erro ao tentar baixar o PDF. Por favor, tente novamente.");
        setShowPopup(true);
        setTimeout(() => {
            setShowPopup(false);
        }, 3000);
    }
}

/**
 * O trecho gratuito do livro.
 *
 * `rodape` é opcional e aparece SOB o visualizador: é onde a página do livro
 * põe a oferta do Clube. Ler o trecho é o momento em que a pessoa acabou de
 * decidir se gostou, e até 03/09/2026 esse momento terminava num "X" — o site
 * abria a amostra e não dizia nada depois dela.
 *
 * NO CELULAR O RODAPÉ NÃO APARECE, e isso é uma limitação conhecida: lá o
 * componente baixa o PDF e se fecha, porque o `<iframe>` de PDF não funciona
 * na maioria dos navegadores móveis. Quem quiser resolver isso precisa antes
 * resolver a visualização, não o rodapé.
 */
const ModalPreview = ({ pdfUrl, onClose, rodape = null }) => {
    const [downloadMessage, setDownloadMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkIsMobile = window.innerWidth <= 768;
        setIsMobile(checkIsMobile);

        if (checkIsMobile) {
            downloadPDF(pdfUrl, setDownloadMessage, setShowPopup, onClose);
        }
    }, [pdfUrl, onClose]);

    const handleClickOutside = (event) => {
        if (event.target.className === "modal-preview") {
            onClose();
        }
    };

    return (
        <>
            {isMobile && <DownloadPopup message={downloadMessage} showPopup={showPopup} />}
            {!isMobile && (
                <div className="modal-preview" onClick={handleClickOutside}>
                    <div className="modal-content">
                        <button className="close-button" onClick={onClose}>
                            X
                        </button>
                        <iframe src={pdfUrl} title="Preview PDF" className="pdf-viewer" />
                        {rodape && <div className="rodape-oferta">{rodape}</div>}
                    </div>
                </div>
            )}
        </>
    );
};

export default ModalPreview;
